import logo from "./logo.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RedocStandalone } from "redoc";
import { loadAndMerge } from "./utils/mergeOpenApi";
import "./App.css";

import DownloadDocsJsonButton from "./components/DownloadDocsJsonButton";

function App() {
    const { t } = useTranslation("common");
    const [spec, setSpec] = useState(null);
    const [error, setError] = useState("");
    const [downloadDocMode, setDownloadDocMode] = useState(false);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const downloadDoc = params.get("downloadDoc");
        console.log(params, "downloadDoc");
        setDownloadDocMode(downloadDoc);
    }, []);
    useEffect(() => {
        const initDocs = async () => {
            try {
                const urls = ["/json-examples/integration-guide.json", "/json-examples/widget.json", "/json-examples/all-api.json"];
                // const urls = [ "/json-examples/all-api.json"];
                const labels = ["Guides", "Function APIs"];
                const merged = await loadAndMerge(urls, labels, {
                    logoUrl: "/logo.svg", // your public logo
                    logoAltText: "VirgoPay-Api",
                    logoBg: "transparent",
                    logoHref: "/", // optional click target
                });
                setSpec(merged);
            } catch (e) {
                setError(String(e?.message || e));
            }
        };
        initDocs();
    }, []);
    if (error) return <pre style={{ color: "crimson", padding: 16 }}>{error}</pre>;
    if (!spec) return <div style={{ padding: 16 }}>Loading…</div>;
    if (downloadDocMode) {
        return (
            <div>
                <DownloadDocsJsonButton path={"Integration Guide"} />
                <DownloadDocsJsonButton path={"widget"} />
            </div>
        );
    }
    return (
        <div id="redoc" style={{ height: "100vh" }}>
            {/* for static json download */}
            {/* <DownloadDocsJsonButton/> */}
            <RedocStandalone
                // specUrl="/json-examples/all-api.json"
                // specUrl="/json-examples/documentations.json"
                spec={spec}
                options={{
                    // UX
                    pathInMiddlePanel: true,
                    expandResponses: "200,201,4xx",
                    requiredPropsFirst: true,
                    onlyRequiredInSamples: false,
                    jsonSampleExpandLevel: "all",
                    hideDownloadButton: false,
                    codeSampleLanguages: [{ lang: "curl" }, { lang: "JavaScript" }, { lang: "Python" }],
                    // theming
                    theme: {
                        colors: { primary: { main: "#455472" } },
                        sidebar: { backgroundColor: "#0b1220", textColor: "#fff" },
                        typography: { fontSize: "14px", headings: { fontWeight: "600" } },
                        rightPanel: { backgroundColor: "#455472" },
                    },
                }}
            />
        </div>
    );
}

export default App;
